import React, { useEffect, useState } from "react";
import { FaEnvelope, FaUser, FaPaperPlane, FaPhone } from "react-icons/fa";
import { FiMessageSquare } from "react-icons/fi";
import emailjs from "emailjs-com";
import AOS from "aos";
import "aos/dist/aos.css";

// --- POPRAWIONY Komponent do danych kontaktowych ---
// Teraz dane są zawsze widoczne, a stan służy tylko do informacji o skopiowaniu.
const ContactLine = ({ icon, text }) => {
    const [isCopied, setIsCopied] = useState(false);

    // Nie renderuj komponentu, jeśli nie ma tekstu
    if (!text) return null;

    const handleCopy = () => {
        navigator.clipboard.writeText(text).then(() => {
            setIsCopied(true); // Pokaż komunikat "Skopiowano!"
            setTimeout(() => setIsCopied(false), 2000); // Wróć do normalnego stanu po 2 sekundach
        }).catch(err => {
            console.error("Nie udało się skopiować:", err);
        });
    };

    return (
        <button
            onClick={handleCopy}
            className="flex items-center gap-4 text-gray-600 hover:text-gray-900 transition-colors w-full text-left"
            aria-label={`Skopiuj ${text}`}
        >
            {React.createElement(icon, { className: "text-gray-400 text-xl flex-shrink-0" })}
            {/* Warunkowo wyświetla tekst: albo oryginalny, albo informację o skopiowaniu */}
            <span className="text-base font-medium">
                {isCopied ? "Skopiowano!" : text}
            </span>
        </button>
    );
};

// --- Ulepszony komponent pola formularza (bez zmian) ---
const InputField = ({ id, label, icon, type = "text", value, onChange }) => (
    <div>
        <label htmlFor={id} className="text-sm font-semibold text-gray-800 flex items-center gap-2 mb-2">
            {React.createElement(icon, { className: "text-gray-400" })} {label}
        </label>
        {type === "textarea" ? (
            <textarea
                id={id}
                name={id}
                value={value}
                onChange={onChange}
                rows="5"
                className="w-full border-b-2 border-gray-200 focus:border-gray-900 outline-none p-2 transition-colors bg-transparent"
                required
            />
        ) : (
            <input
                id={id}
                name={id}
                type={type}
                value={value}
                onChange={onChange}
                className="w-full border-b-2 border-gray-200 focus:border-gray-900 outline-none p-2 transition-colors bg-transparent"
                required
            />
        )}
    </div>
);


// --- Główny komponent Contact ---
const Contact = () => {
    const [formData, setFormData] = useState({ name: "", email: "", message: "" });
    const [contactInfo, setContactInfo] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    useEffect(() => {
        fetch("https://www.wltz.space/php/src/api/zarzadzanie.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ action: "get_management" }),
        })
            .then((res) => res.json())
            .then((data) => setContactInfo(data.management.CONTACT || {}))
            .catch((err) => console.error("Error:", err));

        AOS.init({ duration: 1000, once: true });
    }, []);

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.name || !formData.email || !formData.message) {
            setError("Wszystkie pola są wymagane.");
            return;
        }

        setIsSubmitting(true);
        setError("");
        setSuccess("");

        emailjs
            .send("service_mvc1i8j", "template_sv4cs94", formData, "WkbubIL6__yDJts-Z")
            .then(() => {
                setSuccess("Wiadomość została wysłana pomyślnie!");
                setFormData({ name: "", email: "", message: "" });
            })
            .catch(() => setError("Wystąpił błąd podczas wysyłania wiadomości."))
            .finally(() => setIsSubmitting(false));
    };

    return (
        <div className="max-w-6xl mx-auto  py-20">
            <div className="text-center mb-16" data-aos="fade-up">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 uppercase">
                    {contactInfo.subtitle || "SKONTAKTUJ SIĘ Z NAMI!"}
                </h2>
                <div className="w-96 h-0.5 bg-[#a07c5c] mx-auto my-4"></div>
                <p className="text-gray-500 mt-4 max-w-2xl mx-auto">
                    {contactInfo.description || "Jesteśmy dostępni, aby odpowiedzieć na Twoje pytania. Wypełnij formularz lub skorzystaj z poniższych danych."}
                </p>
            </div>

            <section className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-start">

                {/* Lewa kolumna: Dane kontaktowe */}
                <div className="" data-aos="fade-right">
                    <h3 className="text-xl font-bold text-gray-900 uppercase tracking-wider">
                        Dane kontaktowe
                    </h3>
                    <p className="text-sm text-gray-500">
                        Kliknij, aby skopiować numer lub e-mail.
                    </p>
                    <div className="mt-4 space-y-4">
                        <ContactLine icon={FaPhone} text={contactInfo.phone_1} />
                        <ContactLine icon={FaPhone} text={contactInfo.phone_2} />
                        <ContactLine icon={FaEnvelope} text={contactInfo.email} />
                    </div>
                    <div id="google-map" className="w-full mt-8">
                        <iframe
                            title="Lokalizacja firmy"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d161113.19078528656!2d20.87044114735157!3d52.23306535632315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ecc53d8785a97%3A0x72a6860e867d4f8d!2sWarszawa!5e0!3m2!1spl!2spl!4v1622621852732!5m2!1spl!2spl"
                            className="w-full h-53 sm:h-80"
                            style={{border: '0'}}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                </div>

                {/* Prawa kolumna: Formularz */}
                <div data-aos="fade-left">
                    <h3 className="text-xl font-bold text-gray-900 uppercase tracking-wider">
                        Formularz kontaktowy
                    </h3>
                    <p className="text-sm text-gray-500 mb-8">
                        {contactInfo.form_subtitle || "Masz pytanie? Napisz do nas!"}
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <InputField
                            id="name"
                            label="Imię i Nazwisko"
                            icon={FaUser}
                            value={formData.name}
                            onChange={handleChange}
                        />
                        <InputField
                            id="email"
                            label="Adres Email"
                            icon={FaEnvelope}
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                        <InputField
                            id="message"
                            label="Treść Wiadomości"
                            icon={FiMessageSquare}
                            type="textarea"
                            value={formData.message}
                            onChange={handleChange}
                        />

                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="w-full py-3 rounded-lg bg-gray-900 text-white font-semibold flex items-center justify-center gap-2 hover:bg-gray-800 transition-transform transform active:scale-95 disabled:opacity-50"
                        >
                            <FaPaperPlane /> {isSubmitting ? 'Wysyłanie...' : 'Wyślij wiadomość'}
                        </button>

                        {error && <p className="text-red-500 text-center text-sm mt-4">{error}</p>}
                        {success && <p className="text-green-600 text-center text-sm mt-4">{success}</p>}
                    </form>
                </div>
            </section>        </div>
    );
};

export default Contact;